import { Button, Card, Col, Row, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "./index.less";

const { Title, Paragraph } = Typography;

const HomePageQuestionSection = () => {
  const { t } = useTranslation();
  const cardArr = [
    {
      head: "how-to-become-creator",
      point1: "how-to-become-creator-desc1",
      point2: "how-to-become-creator-desc2",
      btntext: "register-as-a-creator",
      link: "/auth/signUp?currentTab=creator",
    },
    {
      head: "who-can-register-on-twizz",
      point1: "who-can-register-on-twizz-desc",
      btntext: "sign-up",
      link: "/auth/signUp",
      point3: "who-can-register-on-twizz-point-1",
      point4: "who-can-register-on-twizz-point-2",
      point5: "who-can-register-on-twizz-point-3",
    },
    {
      head: "how-to-earn-money-with-twizz",
      point1: "how-to-earn-money-with-twizz-desc1",
      point2: "how-to-earn-money-with-twizz-desc2",
      btntext: "go-to-twizz",
      link: "/auth/intro",
    },
    {
      head: "how-does-twizz-protect-content",
      point1: "how-does-twizz-protect-content-desc",
      btntext: "go-to-twizz",
      link: "/auth/intro",
      point3: "how-does-twizz-protect-content-point-1",
      point4: "how-does-twizz-protect-content-point-2",
      point5: "how-does-twizz-protect-content-point-3",
      point6: "how-does-twizz-protect-content-point-4",
    },
    {
      head: "how-do-i-withdraw-money",
      point1: "how-do-i-withdraw-money-desc",
      btntext: "go-to-twizz",
      link: "/auth/intro",
    },
  ];

  return (
    <Row className="HeroSectionQuestionCardWrapper" justify="center">
      <div className="QuestionCardContainer">
        <div className="QuestionCardTitle">{t("if-you-have-any-questions-text")} </div>
        <Row gutter={[30, 30]}>
          {cardArr.map((item, index) => (
            <Col key={index} xs={24} md={index > 2 ? 12 : 8}>
              <Card className="QuestionCardsCard">
                <Title level={2} className="CardTitle">
                  {t(item.head)}
                </Title>
                <Paragraph className="QuestionCardsText">{t(item.point1)}</Paragraph>
                {item.point2 && <Paragraph className="QuestionCardsText">{t(item.point2)}</Paragraph>}
                {item.point3 && <Paragraph className="QuestionCardsText">- {t(item.point3)}</Paragraph>}
                {item.point4 && <Paragraph className="QuestionCardsText">- {t(item.point4)}</Paragraph>}
                {item.point5 && <Paragraph className="QuestionCardsText">- {t(item.point5)}</Paragraph>}
                {item.point6 && <Paragraph className="QuestionCardsText">- {t(item.point6)}</Paragraph>}
                <Link to={item.link || "/auth/signUp"}>
                  <Button className="QuestionCardButton">{t(item.btntext)}</Button>
                </Link>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </Row>
  );
};

export default HomePageQuestionSection;
